// src/utils/jouer.js

export const parcoursExterieur = [
    1, 2, 3, 4, 5,       // Ligne haut (gauche à droite)
    10, 15, 20, 25,      // Colonne droite (haut en bas)
    24, 23, 22, 21,      // Ligne bas (droite à gauche)
    16, 11, 6            // Colonne gauche (bas en haut)
];

/**
 * Calcule le chemin complet d'un pion case par case sur le contour extérieur
 * @param {number} positionActuelle - L'ID de la case de départ
 * @param {number} resultatDe - Le chiffre du dé
 * @returns {Array} - Tableau contenant les IDs des cases à traverser
 */
export const calculerChemin = (positionActuelle, resultatDe) => {
    let indexActuel = parcoursExterieur.indexOf(positionActuelle);

    // Si le pion n'est pas sur le contour extérieur (ex: retour de maison ou case spéciale), on repart du début ou de la case 1
    if (indexActuel === -1) {
        indexActuel = 0; 
    }

    const chemin = [];
    for (let i = 1; i <= resultatDe; i++) {
        const nouvelIndex = (indexActuel + i) % parcoursExterieur.length;
        chemin.push(parcoursExterieur[nouvelIndex]);
    }
    return chemin; 
};